const AUTOMATIC_CONNECT_NOT_PRESENT = -1;
const AUTOMATIC_CONNECT_FALSE = 0;
const AUTOMATIC_CONNECT_TRUE = 1;

const TAX_DISPLAY_TYPE_EXCL_TAX = 1;
const TAX_DISPLAY_TYPE_INCL_TAX = 2;
const TAX_DISPLAY_TYPE_BOTH = 3;

export default {
  AUTOMATIC_CONNECT_NOT_PRESENT,
  AUTOMATIC_CONNECT_FALSE,
  AUTOMATIC_CONNECT_TRUE,
  TAX_DISPLAY_TYPE_EXCL_TAX,
  TAX_DISPLAY_TYPE_INCL_TAX,
  TAX_DISPLAY_TYPE_BOTH
};
